import './style';
import App from './components/app';
import './i18n';

export default App;
